import { Pipe, PipeTransform } from '@angular/core';
import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { AgentSearchService } from 'ag-common-svc/lib/services/agent-search';
import { Agent } from '@ag-common-lib/lib/models/domain/agent.model';
import { QueryParam, WhereFilterOperandKeys } from 'ag-common-svc/lib/dao/CommonFireStoreDao.dao';

@Pipe({
  name: 'recipientsDataSource',
})
export class RecipientsDataSourcePipe implements PipeTransform {
  constructor(private agentSearchService: AgentSearchService) {}

  async transform(agentsDbId: string[]): Promise<Agent[]> {
    if (!agentsDbId?.length) {
      return [];
    }

    // One ask. The batching this replaces existed because Firestore caps `in` at thirty
    // values.
    const response = await this.agentSearchService.search({
      filter: [BaseModelKeys.dbId, 'anyof', agentsDbId],
    });

    return (response?.data ?? []) as Agent[];
  }
}
